// extracted by mini-css-extract-plugin
export default {"text":"FooterSelectedNumber_text__3mR9J"};